import { lazy } from "react";

export { DYNAMIC_PROCESSES_EDITOR_PATH } from "./dynamic-processes-editor-path";
export const DynamicProcessesEditorPage = lazy(
  () => import("./dynamic-processes-editor"),
);
